import { httpGet, httpPost } from "@/request/http";

let path = "/foodpromotions";

export default {
  getFoods(promotionId) {
    return httpGet(`promotions/${promotionId}/foods`);
  },
  getFoodsByDet(promotionDetId) {
    return httpGet(`promotiondets/${promotionDetId}/foods`);
  },
  postFoods(dto) {
    return httpPost(`${path}/addbatch`, dto);
  },
  removeFoods(dto) {
    return httpPost(`${path}/deletebatch`, dto);
  },
  getFoodKinds(promotionId) {
    return httpGet(`promotions/${promotionId}/foodkinds`);
  },
  getFoodKindsByDet(promotionDetId) {
    return httpGet(`promotiondets/${promotionDetId}/foodkinds`);
  },
  postFoodKinds(dto) {
    return httpPost(`foodkindpromotions/addbatch`, dto);
  },
  removeFoodKinds(dto) {
    return httpPost(`foodkindpromotions/deletebatch`, dto);
  },
};
